/**
 * These are the initial values for the 'startup' redux state.
 */

import { startup_store } from 'src/types'

const store: startup_store = {
  started: false,
}

export default store
